<template>
  <PolicyEmbed
    title="Terms of Service"
    subtitle="The guidelines for playing, merging, and enjoying Spooky Merge."
    src="https://joy2ever-policy.com/spooky-merge/view#spooky-merge_terms-of-service"
  />
</template>

<script>
import PolicyEmbed from '@/components/PolicyEmbed';

export default {
  name: 'TermsOfService',
  components: {
    PolicyEmbed,
  },
};
</script>



// WEBPACK FOOTER //
// src/views/TermsOfService.vue